import { render, staticRenderFns } from "./TaskForm.vue?vue&type=template&id=0edb7dae&scoped=true&"
import script from "./TaskForm.vue?vue&type=script&lang=ts&"
export * from "./TaskForm.vue?vue&type=script&lang=ts&"
import style0 from "./TaskForm.vue?vue&type=style&index=0&id=0edb7dae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edb7dae",
  null
  
)

export default component.exports